'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.DayOfWeek', []).constant('DowConstants', require('./constants/DowConstants')).controller('DayOfWeekController', require('./controllers/DayOfWeekController')).directive('rmDayOfWeek', require('./directives/DayOfWeekDirective'));